import { useState } from 'react';

export default function Catalog() {
  const [viewMode, setViewMode] = useState('iframe'); // 'iframe' or 'quick'
  const [search, setSearch] = useState('');

  return (
    <div className="card" style={{ maxWidth: 1200, margin: '0 auto', padding: '16px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 12, marginBottom: 14 }}>
        <div>
          <h2 style={{ margin: 0, display: 'flex', alignItems: 'center', gap: 8 }}>
            <span>📖</span> Clinical Supplies, Equipment &amp; Services Catalogue
          </h2>
          <p className="muted" style={{ margin: '4px 0 0', fontSize: '0.85rem' }}>
            Official digital flip book and clinical requisition guide for visiting nurses and supervisors.
          </p>
        </div>

        <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
          <a
            href="/catalog.html"
            target="_blank"
            rel="noopener"
            className="ghost sm"
            style={{ textDecoration: 'none', display: 'inline-flex', alignItems: 'center', gap: 6, fontWeight: 700 }}
          >
            <span>↗</span> Open Fullscreen Flip Book
          </a>
          <a
            href="https://wa.me/601154188448?text=Assura%20Nurse%20Desk%20Requisition:%20Requesting%20sterile%20supplies/equipment%20for%20case."
            target="_blank"
            rel="noopener"
            className="pri sm"
            style={{ textDecoration: 'none', display: 'inline-flex', alignItems: 'center', gap: 6, fontWeight: 700, background: '#10b981', borderColor: 'transparent' }}
          >
            <span>💬</span> WhatsApp Requisition
          </a>
        </div>
      </div>

      {/* Embedded 3D Digital Flip Book */}
      <div style={{ width: '100%', height: '820px', borderRadius: '14px', overflow: 'hidden', border: '1.5px solid var(--line)', background: '#030814', boxShadow: '0 10px 30px rgba(0,0,0,0.5)' }}>
        <iframe
          src="/catalog.html"
          title="Assura Clinical Supplies & Services Digital Flip Book"
          style={{ width: '100%', height: '100%', border: 'none' }}
        />
      </div>
    </div>
  );
}
